import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Guid } from 'guid-typescript';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { Equipment } from '../models/equipment';
import { SnotifyService } from 'ng-snotify';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class EquipmentService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public get(id: number): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.get<Equipment>('/api/equipment/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(equipment: Equipment): Promise<Equipment> {
    //Need to do this regardless of put/post
    for (const e of equipment.extras) {
      console.log(e);
      if (!e.id) {
        e.id = Guid.create().toString();
      }
    }

    return new Promise((resolve, reject) => {
      if (equipment.is_edit) {
        this.http.put<Equipment>('/api/equipment/put', equipment).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated equipment');
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        equipment.id = Guid.create().toString();

        this.http.post<Equipment>('/api/equipment/post', equipment).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added equipment');
        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, insurer_Id: number, broker_Id: number, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;

      this.http.get<ServerData>('/api/equipment/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getExcel(page: Page, insurer_Id: number, broker_Id: number, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = '?company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;

      this.http.get<any>('/api/equipment/getexcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }



  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
